import { Duration, intervalToDuration, addMilliseconds } from 'date-fns';

export const toDuration = (seconds: number): Duration => {
  return intervalToDuration({ start: 0, end: addMilliseconds(0, seconds * 1000) });
};
